<classic-layout *ngIf="applicationInfo | async as info">

    <ng-container mojoLogoSection>
        <!-- Logo -->
        <div class="flex items-center p-6 pb-0">
            <img
                class="mx-auto w-1/2 h-1/2"
                [src]="brandedMenuImageSrc"
                alt="Logo image">
        </div>
        <div class="p-6 pb-0">
            <!-- App Name -->
            <h1 class="text-xl text-center">{{info.applicationName}}</h1>
        </div>
    </ng-container>



    <ng-container mojoCopyRightNotice>
        <img
        class="mx-auto w-1/2 h-1/2"
        src="assets/poweredbymojo.svg"
        alt="Powered by Mojo image">
        <p class="text-sm text-center">{{info.copyrightInformation}}</p>
    </ng-container>

</classic-layout>

<settings *ngIf="settingsAccessEnabled()"></settings>
